import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useShop } from "@/context/ShopContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useShop();

  if (wishlist.products.length === 0) {
    return (
      <div data-testid="wishlist-empty" className="mx-auto max-w-3xl px-4 py-24 text-center">
        <Heart className="mx-auto text-muted-soft" size={40} />
        <h1 className="mt-6 text-3xl font-extrabold tracking-tightest text-ink">В избранном пусто</h1>
        <p className="mt-3 text-sm text-muted">Отмечайте товары сердечком, чтобы вернуться к ним позже.</p>
        <Link to="/" className="mt-8 inline-block rounded-full bg-ink px-6 py-3 text-sm font-semibold text-white">В каталог</Link>
      </div>
    );
  }

  return (
    <div data-testid="wishlist-page" className="mx-auto max-w-7xl px-4 py-10 lg:px-8">
      <div className="mb-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Избранное</div>
        <h1 className="mt-2 text-4xl font-extrabold tracking-tightest text-ink md:text-5xl">
          {wishlist.count} {wishlist.count === 1 ? "товар" : "товаров"}
        </h1>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {wishlist.products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </div>
  );
}
